import { Zap } from "lucide-react";

// Success state for Erase and Redraw. Renders for 1.5s after a successful
// cancellation, then the parent dismisses the sheet. Shows the measured
// push-dispatch time as evidence of the 10-second delivery guarantee.
export function EraseDoneStep({ maxDeliveryMs }) {
  return (
    <div data-testid="erase-done" style={{ padding: "20px 8px", textAlign: "center" }}>
      <div style={{
        width: 48, height: 48, borderRadius: 999,
        background: "#E1F5EE", color: "var(--sport-baseball-fg)",
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        marginBottom: 12,
      }}>
        <Zap size={24} aria-hidden="true" />
      </div>
      <div style={{ fontSize: 16, fontWeight: 500, color: "var(--chalk-board)" }}>
        Erased. Families notified.
      </div>
      {maxDeliveryMs != null && (
        <div
          data-testid="erase-timing"
          style={{ fontSize: 12, color: "var(--chalk-muted)", marginTop: 6 }}
        >
          Push dispatched in {maxDeliveryMs} ms.
        </div>
      )}
    </div>
  );
}
